import PropTypes from "prop-types";
import React from "react";

import FormButton from "../../components/form/FormButton";
import ModalFooter from "../../components/modal/ModalFooter";
import ModalFooterRightGroup from "../../components/modal/ModalFooterRightGroup";

const PrintPreviewFooter = props => {
  return (
    <ModalFooter>
      <ModalFooterRightGroup>
        <FormButton primary={true} label={props.buttonLabel} onClick={props.onPrintClick} disabled={!props.canPrint} />
      </ModalFooterRightGroup>
    </ModalFooter>
  );
};

PrintPreviewFooter.defaultProps = {
  buttonLabel: "Print"
};

PrintPreviewFooter.propTypes = {
  buttonLabel: PropTypes.string,
  canPrint: PropTypes.bool,
  onPrintClick: PropTypes.func
};

export default PrintPreviewFooter;
